export const paths = {
 // Hairstudio
 root: '/',
 missionHairstudio: '/mission-hairstudio', 
 storyHairstudio: '/story-hairstudio',
 aboutHairstudio: '/about-hairstudio',
 location: '/location-hairstudio',
 contactus: '/contactus-hairstudio',
 careers: '/careers',
 services: '/services-hairstudio',
 products: '/products-hairstudio',
 branch: '/branch-hairstudio',
 
 // Academy
 academy: '/academy',
 aboutAcademy: '/about-academy',
 missionAcademy: '/mission-academy',
 programAcademy: '/programs-academy',
 packagesAcademy: '/packages-academy', 
 trainingCenterAcademy: '/training-center-academy',
 galleryAcademy: '/gallery-academy',

 // Branch
 branchJakarta: 'branch-hairstudio/jakarta-branch',
 branchArizona: 'branch-hairstudio/arizona-branch',
 branchBoston: 'branch-hairstudio/boston-branch',
 

 // Error
 notFound: '*',
}